import { Space, Typography } from 'antd'
import { RFINotificationEvent } from 'shared'

const RFINotificationsDetails: React.FC = () => {
  return (
    <Space direction="vertical">
      <Typography.Text>
        Users assigned to Response Disciplines will always receive notifications
        for {RFINotificationEvent.Submitted.name} and{' '}
        {RFINotificationEvent.Response.name}s from Disciplines they are assigned
        to.
      </Typography.Text>
      <Typography.Text>
        Submitting user will always receive notifications for{' '}
        {RFINotificationEvent.Submitted.name},{' '}
        {RFINotificationEvent.Response.name}s,{' '}
        {RFINotificationEvent.Closed.name}, and{' '}
        {RFINotificationEvent.Commented.name}.
      </Typography.Text>
    </Space>
  )
}

export default RFINotificationsDetails
